import { api } from "@/api";
import {
  UpsertBettingMarketSuspensionsParams,
  BettingMarketSuspensionsEditorResponse,
} from "@/types/ApiResponses/BettingMarket";

export const upsertBettingMarketsSuspensions = async (
  data: UpsertBettingMarketSuspensionsParams
): Promise<BettingMarketSuspensionsEditorResponse> => {
  const res = await api.client.post(`/betting-markets-new/suspensions`, data);
  return res.data;
};
